import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'
import Profile from '@/views/Profile.vue'
import ErrorRouteNotFound from '@/views/error/RouteNotFound.vue'
import ErrorInsufficientPermissions from '@/views/error/InsufficientPermissions.vue'
import AppointmentRoutes from './appointment'
import DentistRoutes from './dentist'
import OperatorRoutes from './operator'
import AdminRoutes from './admin'
import RequestRoutes from './request'
import TicketRoutes from './ticket'
import EnquiryRoutes from './enquiries'


Vue.use(Router)

const baseRoutes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      auth: 'all',
      layout: {
        topbar: false,
        footer: false
      }
    }
  },
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      auth: 'all',
      breadcrumbs: [
        {
          link: 'dashboard',
          title: 'Dashboard'
        }
      ]
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      auth: 'all',
      breadcrumbs: [
        {
          link: 'profile',
          title: 'User Profile'
        }
      ]
    }
  },
  {
    path: '/eip',
    name: 'error-insufficient-permissions',
    component: ErrorInsufficientPermissions,
    meta: {
      auth: 'all'
    }
  },
  {
    path: '*',
    name: '404',
    component: ErrorRouteNotFound,
    meta: {
      auth: 'all'
    }
  }
]

const routes = baseRoutes.concat(AppointmentRoutes, DentistRoutes, OperatorRoutes, AdminRoutes, RequestRoutes, TicketRoutes, EnquiryRoutes)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
